import { useDeepCompareMemo } from "@react-hookz/web";
import type { UUID } from "../../../utils/uuid";
import { useEmailDesigns } from "../../email-design/hooks/use-email-design";
import type { EmailDesign } from "../../email-design/server/supabase-email-design-service";

export function useSelectedEmailDesign(email_design_id: UUID | null): EmailDesign | null {
  const { data: emailDesigns } = useEmailDesigns();

  const selectedEmailDesign = useDeepCompareMemo(() => {
    const predicate = email_design_id
      ? (x: EmailDesign) => x.id === email_design_id
      : (x: EmailDesign) => x.is_default;

    return emailDesigns?.find(predicate) ?? null;
  }, [email_design_id, emailDesigns]);

  return selectedEmailDesign;
}
